// GET

import axios from 'axios';
import { DefaultSiteProfile } from '../types/default-site-profile.type';

// /ewosapi/v2/planandprognosis/default-profile/site/{globalSiteId}
export const getDefaultSiteProfile = async (globalSiteId: string): Promise<DefaultSiteProfile> => {
  const res = await axios.get<DefaultSiteProfile>(`/ewosapi/v2/planandprognosis/default-profile/site/${globalSiteId}`);
  return res.data;
};
